/* eslint-disable @typescript-eslint/no-explicit-any */
import { ZXingScannerComponent } from '@zxing/ngx-scanner';

(ZXingScannerComponent as any).prototype['releaseMediaStream'] =
  function patchedRelease(): void {
    const track = this._stream?.getVideoTracks?.()[0];

    /** Solo apagar el flash si el track está vivo (Chrome M121+) */
    if (track?.readyState === 'live') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore – prop interna de la lib
      this.imageCapture?.setOptions({ torch: false }).catch(() => {});
    }

    track?.stop();
  };